import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Timeline tab body (SWOOP-254 US5), rendered inside the work-order page layout at
 * `/work-orders/$workOrderId/timeline`. Permission / module gating is inherited from the layout route's
 * `beforeLoad`.
 */
export const Route = createFileRoute('/_authenticated/work-orders_/$workOrderId/timeline')({
  component: lazyRouteComponent(() => import('&/features/work-orders/pages/work-order-timeline-tab')),
  staticData: { titleKey: 'workOrderTimeline' },
});
